import { Link } from 'react-router-dom';

const stats = [
  { value: '5,200+', label: '影视资源' },
  { value: '1,800+', label: '资讯文章' },
  { value: '600万', label: '月活跃用户' },
  { value: '12年', label: '行业沉淀' },
];

const introImage =
  'https://readdy.ai/api/search-image?query=stylish%20home%20cinema%20room%20with%20a%20large%20glowing%20screen%20warm%20ambient%20lighting%20deep%20blue%20evening%20atmosphere%20cozy%20modern%20interior%2C%20editorial%20photography&width=900&height=1100&seq=intro-visual&orientation=portrait';

export default function SiteIntro() {
  return (
    <section className="max-w-8xl mx-auto px-4 md:px-8 py-12 md:py-16">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
        <div>
          <span className="inline-block text-xs font-bold tracking-[0.25em] text-accent-600 font-label mb-3">ABOUT US</span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-snug">
            关于翔田千里影视大全
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
            翔田千里影视大全是一个专注于影视资源展示与影视资讯发布的综合平台。我们汇聚最新电影、电视剧的详细信息，及时报道行业动态与影片口碑，帮助你在海量内容中快速找到想看的那一部。
          </p>
          <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
            无论你是资深影迷还是偶尔追剧的观众，都能在这里获得清晰、专业、流畅的观影发现体验。
          </p>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-8">
            {stats.map((s) => (
              <div key={s.label} className="p-4 rounded-lg bg-background-100 border border-background-200">
                <p className="font-heading text-xl md:text-2xl font-bold text-primary-600">{s.value}</p>
                <p className="mt-1 text-xs text-foreground-500">{s.label}</p>
              </div>
            ))}
          </div>

          <Link
            to="/category?type=movie"
            className="mt-8 inline-flex items-center gap-2 h-11 px-6 rounded-md bg-primary-600 text-background-50 text-sm font-semibold hover:bg-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-compass-3-line text-lg"></i>
            开始探索影视资源
          </Link>
        </div>

        <div className="relative w-full h-[300px] md:h-[420px] rounded-lg overflow-hidden">
          <img
            src={introImage}
            alt="翔田千里影视大全"
            title="翔田千里影视大全 - 影视资源与资讯平台"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-primary-950/60 to-transparent"></div>
          <div className="absolute bottom-5 left-5 right-5 flex items-center gap-3 p-4 rounded-lg bg-background-50/95 backdrop-blur">
            <span className="w-11 h-11 rounded-lg bg-accent-500 flex items-center justify-center text-primary-950 shrink-0">
              <i className="ri-shield-star-line text-2xl"></i>
            </span>
            <div>
              <p className="text-sm font-semibold text-foreground-950">专业影视资讯与资源平台</p>
              <p className="text-xs text-foreground-500 mt-0.5">内容及时、分类清晰、体验流畅</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}